<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)">
		<div class="ld-panel-title">
			<router-link to="/hosts" class="back-btn"><span></span>备份管理</router-link>
		</div>
		<div class="ld-panel-main">
			<el-button type="primary" class="add" @click="dialogGroupVisible = true">创建自动备份</el-button>
			<div class="search-main clear">
				<el-input v-model="searchInput" class="input" placeholder="请输入搜索内容..." clearable @clear="handleEmpty"></el-input>
				<span @click="searchClick" class="btn"></span>
			</div>
			<el-alert title="温馨提示：" type="warning" :closable="false" style="margin-bottom: 20px;">
				<template #default>
					<p>① 蓝队云为您的云数据库提供免费的备份额度。建议您启用自动备份功能以增强数据安全性；</p>
					<p>② 您可以根据业务需求自定义安排完整备份和增量备份的时间策略，系统将按照任务配置自动执行备份；</p>
					<p>③ 每个云数据库实例目前仅支持配置一个自动备份任务，并且系统默认只保留最新的全量备份文件。请合理规划您的备份策略以避免重要数据丢失；</p>
					<p>④ 在备份MyISAM类型的表时会使用全局读锁，这会导致所有DML（数据操作语言）操作暂时无法提交。请慎重选择备份时间，尽量减少对业务的影响；</p>
					<p>⑤ 当前备份恢复功能正在升级优化中。若您需要恢复备份数据，请通过提交后台工单来获取帮助。</p>
				</template>
			</el-alert>
			<el-table :data="tableData" v-loading="loading" style="width: 100%">
				<el-table-column label="实例 ID(名称)" width="330">
					<template #default="scope">
						<span class="instance_name">{{scope.row.instance_id}}</span>
						<span v-if="scope.row.instance_name">({{scope.row.instance_name}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="rule_name" label="备份任务名称" />
				<el-table-column prop="start_time" label="完整备份开始时间" />
				<el-table-column prop="frequency_text" label="增量备份频率" />
				<el-table-column label="是否启用">
					<template #default="scope">
						<el-switch v-show="scope.row.loading" loading :active-value="1" :inactive-value="0" v-model="scope.row.enabled" />
						<el-switch v-show="!scope.row.loading" :active-value="1" :inactive-value="0" @click="switchChange(scope.row,scope.$index)" v-model="scope.row.enabled" />
					</template>
				</el-table-column>
				<el-table-column label="操作" width="170">
				  <template #default="scope">
					  <el-button link type="primary" size="small" v-if="scope.row.enabled == 0" @click="rowOperation(scope.row,'edit')">编辑</el-button>
					  <el-button link type="primary" size="small" @click="rowOperation(scope.row,'record')">备份记录</el-button>
					  <el-button link type="danger" size="small" v-if="scope.row.enabled == 0" @click="rowOperation(scope.row,'delete')">删除</el-button>
				  </template>
				</el-table-column>
			</el-table>
			<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
		</div>
		<!-- 创建自动备份 -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogGroupVisible" title="创建自动备份">
			<el-alert title="自动备份将在到达下一次完整备份开始时间时启动!" type="warning" show-icon :closable="false" style="margin-bottom: 20px;" />
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
				<el-form-item label="所属实例" prop="instance_id">
					<el-select v-model="groupForm.instance_id">
						<el-option v-for="item in exampleOptions" :key="item.instance_id" :value="item.instance_id" :label="item.instance_name +'('+item.instance_id+')'"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="完整备份开始时间" prop="start_times">
					<el-time-picker v-model="groupForm.start_times" format="HH:mm:ss" value-format="HH:mm:00" placeholder="请选择备份开始时间" />
				</el-form-item>
				<el-form-item label="增量备份频率" prop="frequencyKey">
					<el-select v-model="groupForm.frequencyKey">
						<el-option v-for="item in frequencyOptions" :key="item.key" :value="item.key" :label="item.text"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetForm(ruleFormRef)">取消</el-button>
					<el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 备份记录 -->
		<el-dialog width="800" align-center v-model="dialogTableVisible" :close-on-click-modal="false" title="备份记录">
			<el-table :data="recordData" max-height='600' v-loading="loading1" style="width: 100%">
				<el-table-column prop="start_time" label="备份开始时间" width="160" />
				<el-table-column prop="finish_time" label="备份结束时间" width="160" />
				<el-table-column prop="size_info.size" label="备份文件大小" width="140" />
				<el-table-column prop="s3_location" label="备份文件地址" />
			</el-table>
			<pageList :pagination="pagination1" :paginationTotal="paginationTotal1" @handleSizeChange="handleSizeChange1" @handleCurrentChange="handleCurrentChange1"></pageList>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted,nextTick } from 'vue';
	import { fetchExample } from '@/api/users';
	import { fetchList,backupCreat,backupDelete,backupSwitch,taskList } from '@/api/backup';
	import pageList from '../../components/pageList.vue';
	import tableList from '../../components/tableList.vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const fullscreenLoading = ref(false);
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const loading = ref(true);
	const pagination1 = reactive({page: 1,size: 10});
	const paginationTotal1 = ref(0);
	const loading1 = ref(true);
	const searchInput = ref('');
	const dialogTableVisible = ref(false);
	const recordData = ref();
	const taskId = ref(0);
	const dialogGroupVisible = ref(false);
	const formLabelWidth = ref('150');
	const exampleOptions = ref();
	const tableData = ref();
	const frequencyOptions = reactive([
		{
			key: '1',
			text: '每1小时一次'
		},
		{
			key: '2',
			text: '每2小时一次'
		},
		{
			key: '4',
			text: '每4小时一次'
		},
		{
			key:'6',
			text:'每6小时一次'
		}
	]);
	const frequencySelect = ref(1);
	const expireSelect = ref('1');
	const ruleFormRef = ref(null);
	const groupForm = ref({id:taskId.value,instance_id:'',start_times:'',frequencyKey:''})
	const rules = reactive({
		instance_id: [
			{ required: true, message: '请选择实例', trigger: 'blur' },
		],
		start_times: [
			{ required: true, message: '请选择备份开始时间', trigger: 'blur' },
		],
		frequencyKey: [
			{ required: true, message: '请选择备份频率', trigger: 'blur' },
		]
	});
	
	
	const fetchExampleF = () => {
		const param = {'page':1,'size':9999}
		fetchExample(param).then((res) => {
			exampleOptions.value = res.data.list;
		})
	};
	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'search':searchInput.value
		}
		fetchList(param).then((res) => {
			paginationTotal.value = res.data.count;
			const data = res.data.list;
			for (var i = 0; i < data.length; i++) {
				const frequencys = frequencyOptions.find(item => parseInt(item.key) === data[i].frequency);
				data[i].start_time = getDateM(data[i].start_time);
				data[i].frequency_text = frequencys.text;
			}
			tableData.value = data;
			loading.value = false;
		})
	};
	const rowOperation = (row, now) => {
		if(now == 'edit'){
			dialogGroupVisible.value = !dialogGroupVisible.value;
			nextTick(() => {
			    Object.assign(groupForm.value,row);
				const time = row.start_time;
				groupForm.value.start_times = time.substring(time.indexOf(" ") + 1);
				groupForm.value.frequencyKey = String(row.frequency);
			})
		}
		if (now == 'record') {
			taskId.value = row.id;
			dialogTableVisible.value = !dialogTableVisible.value;
			taskListF()
		}
		if(now == 'delete'){
			const param = {"id": row.id}
			ElMessageBox.confirm(
				'确定要删除该数据吗？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				backupDelete(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							type: 'success',
							message: res.msg,
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
	};
	const taskListF = () => {
		loading1.value = true;
		const param = {
			'page':pagination1.page,
			'size':pagination1.size,
			'id':taskId.value
		}
		taskList(param).then((res) => {
			paginationTotal1.value = res.data.count;
			const data = res.data.list;
			for (var i = 0; i < data.length; i++) {
				data[i].start_time = getDateF(data[i].start_time);
				data[i].finish_time = data[i].finish_time == null ? '':getDateF(data[i].finish_time);
			}
			recordData.value = data;
			loading1.value = false;
		})
	};
	const switchChange = (row,index) => {
		tableData.value[index].loading = true;
		const param = {'id':row.id,'enabled':row.enabled}
		backupSwitch(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
			}
			fetchListF()
		})
	}
	const submitForm = () => {
	  if (!ruleFormRef.value) return;
	  ruleFormRef.value.validate((valid) => {
	    if (valid) {
			fullscreenLoading.value = true;
			groupForm.value.frequency = parseInt(groupForm.value.frequencyKey);
			groupForm.value.start_time = timeString(groupForm.value.start_times);
			const param = groupForm.value;
			backupCreat(param).then((res) => {
				if(res.code === 200){
					ElMessage({
						offset:70,
						message: res.msg,
						type: 'success'
					})
					resetForm()
					fetchListF()
				}
				fullscreenLoading.value = false;
			})
	    } else {
	      return false;
	    }
	  });
	};
	const resetForm = () => {
		groupForm.value = {id:taskId.value,instance_id:'',start_times:'',frequencyKey:''};
		ruleFormRef.value.resetFields();
		dialogGroupVisible.value = !dialogGroupVisible.value;
	}
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF();
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF();
	};
	const handleCurrentChange1 = (e) => {
		pagination1.page = e;
		taskListF();
	};
	const handleSizeChange1 = (e) => {
		pagination1.size = e;
		taskListF();
	};
	const searchClick = () => {
		fetchListF()
	};
	const handleEmpty = () => {
		fetchListF()
	};
	const timeString = (timeStr) => {
		const parts = timeStr.split(':').map(Number);
		const hours = parts[0];
		const minutes = parts[1];
		const seconds = parts[2];
		const date = new Date();
		date.setHours(hours, minutes, seconds, 0); // 设置时间
		return date.toISOString();
	}
	const getDateF = (string) => {
    	var date = new Date(string);
    	var year = date.getFullYear();
    	var month = date.getMonth() + 1;
    	var day = date.getDate();
    	var hours = date.getHours();
    	var minute = date.getMinutes();
    	let second = date.getSeconds();
		month = month < 10 ? "0" + month : month;
		day = day < 10 ? "0" + day : day;
		hours = hours < 10 ? "0" + hours : hours;
		minute = minute < 10 ? "0" + minute : minute;
		second = second < 10 ? "0" + second : second;
    	var currentdate = year + "-" + month + "-" + day + " " + hours + ":" + minute + ":" + second;
    	return currentdate
    }
	const getDateM = (string) => {
		var date = new Date(string);
		var hours = date.getHours();
		var minute = date.getMinutes();
		let second = date.getSeconds();
		hours = hours < 10 ? "0" + hours : hours;
		minute = minute < 10 ? "0" + minute : minute;
		second = second < 10 ? "0" + second : second;
		var currentdate = hours + ":" + minute + ":" + second;
		return currentdate
	}
	
	onMounted(() => {
		fetchExampleF()
		fetchListF();
	})
	
	
</script>

<style lang="scss" scoped>
	.search-main{float: right;}
	.el-alert p{line-height:20px}
	.type{
		.text{color: #888;margin-left: 10px;}
		.el-input{width: 50% !important;}
	}
</style>